import { defineStore } from 'pinia'

export const useAuthModalStore = defineStore('authModal', {
  state: () => ({
    visible: false,
    mode: 'login' // 'login' | 'register'
  }),
  actions: {
    open(mode = 'login') {
      this.mode = mode
      this.visible = true
      try {
        document.body.style.overflow = 'hidden'
      } catch (e) {}
    },
    close() {
      this.visible = false
      try {
        document.body.style.overflow = ''
      } catch (e) {}
    },
    toggle(mode) {
      if (mode && (mode === 'login' || mode === 'register')) this.mode = mode
      this.visible = !this.visible
    },
    switchMode() {
      this.mode = this.mode === 'login' ? 'register' : 'login'
    }
  }
})

